import type { FC } from 'react';
import type { VariantsOnTaskIndexProps } from '../../types';
import { observer } from 'mobx-react-lite';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import { Box } from '@mui/material';
import { RuleEditAutocompleteMultiple } from '../index';
import type { OptionValue } from '../../../../types/shared';

const DependingAutocomplete: FC<VariantsOnTaskIndexProps> = observer(({ indexTask, indexVariant }) => {
  const tasksFormStore = useCurrentTasksFormStore();

  const variantsOnTaskValue = tasksFormStore.getVariantsOnTask(indexTask);
  const variantsConditions = variantsOnTaskValue[indexVariant].condition.conditions;
  const selectedConditions = variantsOnTaskValue[indexVariant].__selectedDependenciesOnConditions;

  const conditions =
    variantsConditions
      .filter((condition) => !!condition.metric)
      .map((condition, index) => ({
        value: index,
        label: `Condition ${index + 1} (metric: ${condition.metric} ${condition.second_metric ? `, second_metric: ${condition.second_metric}` : ''})`,
      })) ?? [];

  return (
    <Box sx={{ display: 'flex', width: 'fit-content', minWidth: 420, maxWidth: '100%' }}>
      <RuleEditAutocompleteMultiple
        disableClearable={false}
        sx={{
          '& fieldset': { top: -4 },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid black',
            borderRadius: '10px',
          },
          '& .MuiOutlinedInput-root': {
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: '1px solid black',
              borderRadius: '10px',
            },
          },
          '& .MuiInputBase-root': { borderRadius: '10px !important' },
          '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid black',
          },
        }}
        allSelectable={false}
        value={selectedConditions as OptionValue[]}
        InputProps={{
          label: 'Depending on',
        }}
        onChange={(value) => {
          tasksFormStore.setSelectedDependenciesOnConditions(indexTask, indexVariant, value as number[]);
        }}
        id={`DependingAutocomplete-new-${indexTask}`}
        options={conditions}
      />
    </Box>
  );
});

export default DependingAutocomplete;
